module.exports = __webpack_public_path__ + "img/follow.7c279e5d.png";